<!-- Home page of Vue loaded in main.js -->

<template>
  <v-app id="app">
    <component :is="layout" />
  </v-app>
</template>

<script>
import LoginLayout from "@/layouts/Login.vue";
import OneColumnLayout from "@/layouts/OneColumn.vue";
import TwoColumnsLayout from "@/layouts/TwoColumn.vue";
import NoRoleLayout from "@/layouts/NoRole.vue";
import ThreeColumnsLayout from "@/layouts/ThreeColumn.vue";

export default {
  name: "App",
  computed: {
    layout() {
      const components = {
        login: LoginLayout,
        threeColumns: ThreeColumnsLayout,
        oneColumn: OneColumnLayout,
        twoColumns: TwoColumnsLayout,
        noRole: NoRoleLayout
      };
      return components[this.$route.meta.layout];
    },
  }
};
</script>

<style>
@font-face {
  font-family: 'Montserrat-Regular';
  src: url('~@/assets/fonts/Montserrat-Regular.ttf') format('truetype');
}

#app {
  font-family: Montserrat-Regular,system-ui,-apple-system,Segoe UI,Roboto,Helvetica Neue,Noto Sans,Liberation Sans,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.v-chip .v-chip__content {
  max-width: none !important;
}

.v-application {
   font-family: Montserrat-Regular,system-ui,-apple-system,Segoe UI,Montserrat-Regular,Helvetica Neue,Noto Sans,Liberation Sans,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji !important;
}

.v-application .display-4 {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .display-3 {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .display-2 {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .display-1 {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .headline {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .title {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .subtitle-2 {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .subtitle-1 {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .body-2 {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .body-1 {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .caption {
  font-family: "Montserrat-Regular", sans-serif !important;
}
.v-application .overline {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-h1 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-h2 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-h3 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-h4 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-h5 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-h6 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-subtitle-1 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-subtitle-2 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-body-1 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-body-2 {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-button {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-caption {
  font-family: "Montserrat-Regular", sans-serif !important;
}

.v-application .text-overline {
  font-family: "Montserrat-Regular", sans-serif !important;
}

@media (min-width: 600px) {
  .v-application .text-sm-h1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-h2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-h3 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-h4 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-h5 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-h6 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-subtitle-1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-subtitle-2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-body-1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-body-2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-button {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-caption {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-sm-overline {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
}
@media (min-width: 960px) {
  .v-application .text-md-h1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-h2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-h3 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-h4 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-h5 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-h6 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-subtitle-1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-subtitle-2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-body-1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-body-2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-button {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-caption {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-md-overline {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
}
@media (min-width: 1264px) {
  .v-application .text-lg-h1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-h2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-h3 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-h4 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-h5 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-h6 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-subtitle-1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-subtitle-2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-body-1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-body-2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-button {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-caption {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-lg-overline {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
}
@media (min-width: 1904px) {
  .v-application .text-xl-h1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-h2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-h3 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-h4 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-h5 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-h6 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-subtitle-1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-subtitle-2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-body-1 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-body-2 {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-button {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-caption {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
  .v-application .text-xl-overline {
    font-family: "Montserrat-Regular", sans-serif !important;
  }
}
</style>
